export const getInitials = (text: string | undefined | null): string => {
  if (!text) {
    return "";
  }

  const tmp = text.split(" ").filter((parts: string) => parts.length > 0);
  return `${tmp.at(0)?.at(0)}${tmp.at(-1)?.at(0)}`.toUpperCase();
};
